import { inject, NewInstance } from 'aurelia-framework';
import { PurchaseTypeRuleService } from 'pages/quote-setup/purchase-type-rules/service';
import { ProjectService } from 'pages/quote-setup/projects/service';
import { CustomerService } from 'pages/quote-setup/customers/service';
import { PlantService } from 'pages/quote-setup/plants/service';
import { PurchasePartTypeService } from 'pages/system-fields/purchase-part-types/service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogController } from 'aurelia-dialog';
import { DialogService } from 'aurelia-dialog';
import { ValidationRules, ValidationController, validateTrigger } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'resources/validation-renderer';
import toastr from 'toastr';

@inject(DialogController, NewInstance.of(ValidationController), PurchaseTypeRuleService, ProjectService, CustomerService, PlantService, PurchasePartTypeService, EventAggregator, DialogService)
export class PurchaseTypeRuleEditor {
    constructor(controller, validationController, purchaseTypeRulesService, projectService, customerService, plantService, purchasePartTypeService, ea, dialogService) {
        this.controller = controller;
        this.dialogService = dialogService;
        this.purchaseTypeRulesService = purchaseTypeRulesService;
        this.projectService = projectService;
        this.customerService = customerService;
        this.plantService = plantService;
        this.purchasePartTypeService = purchasePartTypeService;
        this.ea = ea;
        this.purchaseTypeRule = {};

        this.validationController = validationController;
        this.validationController.validateTrigger = validateTrigger.manual;
        this.validationController.addRenderer(new BootstrapFormRenderer());
        this.rules = ValidationRules
            .ensure('markupFactor').required()
            .ensure('projectId').required().withMessage('Project is required')
            .ensure('plantId').required().withMessage('Plant is required')
            .ensure('customerId').required().withMessage('Customer is required')
            .ensure('purchasePartTypeId').required().withMessage('Purchase part type is required')
            .rules;
    }

    async activate(model) {
        if (model?.id != null) {
            this.purchaseTypeRule = await this.purchaseTypeRulesService.getById(model.id);
        }
    }

 

    addProject () {
        this.dialogService.open({ viewModel: this.projectService.editor });
    }

    addCustomer () {
        this.dialogService.open({ viewModel: this.customerService.editor });
    }

    addPlant () {
        this.dialogService.open({ viewModel: this.plantService.editor });
    }

    addPurchasePartType () {
        this.dialogService.open({ viewModel: this.purchasePartTypeService.editor });
    }

    async save() {
        if (this.isRequesting) return;
        this.isRequesting = true;
        const validationResult = await this.validationController.validate();
        if (validationResult.valid) {
            try {
                if (this.purchaseTypeRule.id) {
                    await this.purchaseTypeRulesService.update(this.purchaseTypeRule);
                    toastr.success('Purchase type rule was updated!');
                } else {
                    await this.purchaseTypeRulesService.create(this.purchaseTypeRule);
                    toastr.success('New purchase type rule was created!');
                }
                this.ea.publish('purchase-type-rules:updated', this.purchaseTypeRule);
                this.controller.ok(this.purchaseTypeRule);
            } catch {
                this.isRequesting = false;
            }
        }
        this.isRequesting = false;
    }
}